const STORAGE_KEY = 'ffhub_app_upsell_v1';

export type StoredAppUpsell = {
  /** Epoch ms of the last time the upsell modal was shown. */
  modalLastShownAt: number;
  /**
   * Epoch ms of when the banner was dismissed, if it has been. Only
   * suppresses the banner while it is >= modalLastShownAt; a new modal
   * showing starts a new cycle and the banner returns.
   */
  bannerDismissedAt?: number;
};

export const getStoredAppUpsell = (): StoredAppUpsell | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredAppUpsell;
    if (!Number.isFinite(parsed?.modalLastShownAt)) return null;
    if (
      parsed.bannerDismissedAt !== undefined &&
      !Number.isFinite(parsed.bannerDismissedAt)
    ) {
      return { modalLastShownAt: parsed.modalLastShownAt };
    }
    return parsed;
  } catch {
    return null;
  }
};

export const setStoredAppUpsell = (value: StoredAppUpsell): void => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Silently fail - localStorage may be full or disabled
  }
};
